import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'handleClick'
        }
    }

    init() {
        this.current = this.getData('current')
    }

    handleClick() {
        if(window.handleChangeLocales) {
            if(this.current == 'en') {
                window.handleChangeLocales('1', 'LIVE');
            } else {
                window.handleChangeLocales('0', 'LIVE');
            }
        }
    }
}
